import React, {Component} from "react";
import { Link } from 'react-router-dom';
import withRouter from './../withRouter';
import { global } from './../../config.js';

import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Button from 'react-bootstrap/Button';

import Cookies from 'js-cookie';

import { Editor } from 'react-draft-wysiwyg';
import { EditorState } from 'draft-js';
import './../../../node_modules/react-draft-wysiwyg/dist/react-draft-wysiwyg.css';

import {stateToHTML} from 'draft-js-export-html';
import {stateFromHTML} from 'draft-js-import-html';

class EditorModule extends Component {

    constructor(props) {
      super(props);
      this.state = {
        editorState: EditorState.createEmpty(),
        id: this.props.params.id,
        htmlText: "",
        loading: true,
        saving: false
      }
      
      this.uploadImageCallBack = this.uploadImageCallBack.bind(this)
      this.item = this.item.bind(this)
      this.initEditor = this.initEditor.bind(this)
      this.save = this.save.bind(this)
    
    }

    componentDidMount() {
      this.item()
    }

    item() {
        
      const requestOptions = {
          method: 'GET',
          headers: { 
              'Authorization': 'Bearer ' + Cookies.get('session-acs'),
              'Content-Type': 'application/json',
              "Access-Control-Allow-Origin": "*"
          }
      };

      fetch(global.endpoint_api + '/items/' + this.state.id, requestOptions)
      .then(res => res.json().then(
          (result) => {

              if (res.status === 200 && !result.error) {
                  this.setState({
                      loading: false,
                      htmlText: result.text == null ? "" : result.text
                  }, () => this.initEditor());
              } else {
                  if (result.error) {
                      this.setState({
                          error: result.error.message
                      });
                  } else {
                      this.setState({
                          error: "Произошла ошибка. Пожалуйста, попробуйте позже."
                      });
                  }
              }
              this.setState({
                  loading: false
              });
          }
      ))

  }

  save() {

    const requestOptions = {
        method: 'PUT',
        headers: { 
            'Authorization': 'Bearer ' + Cookies.get('session-acs'),
            'Content-Type': 'application/json',
            "Access-Control-Allow-Origin": "*"
        },
        body: JSON.stringify({html: stateToHTML(this.state.editorState.getCurrentContent())})
    };

    fetch(global.endpoint_api + '/items/' + this.state.id + '/text', requestOptions)
        .then(res => res.json().then(
        (result) => {
            if (res.status === 200 && !result.error) {
                this.setState({
                  htmlText: result.html
                });
            } else if (result.error) {
                this.setState({
                    error: result.error.message
                });
            } else {
                this.setState({
                    error: "Неизвестная ошибка. Пожалуйста, попробуйте позже."
                });
            }

            this.setState({
                updating: false,
            });
        },
        (error) => {}
    ))
}

    initEditor() {
      //const contentBlock = htmlToDraft(this.state.htmlText);
      let contentState = stateFromHTML(this.state.htmlText);
      //if (contentBlock) {
        //const contentState = ContentState.createFromBlockArray(contentBlock.contentBlocks);
        const editorState = EditorState.createWithContent(contentState);
        this.setState({
          editorState,
          contentState
        })
      //}
    }

    uploadImageCallBack(file) {
        return new Promise(
          (resolve, reject) => {
            const xhr = new XMLHttpRequest();
            xhr.open('POST', global.endpoint_api + '/image');
            xhr.setRequestHeader('Authorization', 'Bearer ' + Cookies.get('session-acs'));
            const data = new FormData();
            data.append('file', file);
            xhr.send(data);
            xhr.addEventListener('load', () => {
              const result = JSON.parse(xhr.responseText);
              const response = {
                data: {
                  link: result.Location
                }
              };
              resolve(response);
            });
            xhr.addEventListener('error', () => {
              console.log("%(")
              //const error = JSON.parse(xhr.responseText);
              //reject(error);
            });
          }
        )
    }

    
    onEditorStateChange = (editorState) => {
      this.setState({
        editorState,
      });
      //const html = stateToHTML(editorState.getCurrentContent())
      //console.log(html)
    }

    render() {

      let { saving } = this.state

        return (
            <>
                
              <Row className="mb-4 justify-content-between">
                  <Col>
                      <Link to={"/items/" + this.state.id}>&larr; Назад</Link>
                  </Col>
                  <Col className="d-flex justify-content-end">
                    <Button variant="dark" disabled={saving} onClick={this.save}>Сохранить</Button>
                  </Col>
              </Row>
              <Row className="mb-4 editor">
                <Col className="h-full">
                  <div className="card card-simple h-100">
                    <div className="card-body">
                      <div className="mb-4">
                        <Editor
                            editorState={this.state.editorState}
                            onEditorStateChange={this.onEditorStateChange.bind(this)}
                            toolbar={{
                                options: ['inline', 'blockType', 'fontSize', 'list', 'textAlign', 'link', 'image', 'history'],
                                //inline: { inDropdown: true },
                                list: { inDropdown: true },
                                textAlign: { inDropdown: true },
                                //link:  { inDropdown: true },
                                //history: { inDropdown: true },
                                image: {
                                    uploadCallback: this.uploadImageCallBack,
                                    previewImage: true,
                                    alt: { present: false, mandatory: false },
                                    defaultSize: {
                                      height: '100%',
                                      width: '100%',
                                    },
                                }
                            }}
                            handlePastedText={() => false}
                            localization={{
                              locale: 'ru',
                            }}
                        />
                      </div>
                    </div>
                  </div>
                </Col>
              </Row>

                {/*
                <textarea
                  disabled
                  value={draftToHtml(convertToRaw(this.state.editorState.getCurrentContent()))}
                />
                  */}
                
            </>
        )

    }
}

export default withRouter(EditorModule);